<template>
	<UnidadeLayout>
		<LoaderPage v-if="loadingPage" />
		<nav class="navbar nav-bar-unidade">
			<div class="container-fluid">
				<a class="navbar-brand" href="#">
					{{ vue_app_name }}
				</a>
				<ConsultaSwitch />
			</div>
		</nav>
		<div class="container my-4" style="padding-bottom: 400px;">
			<div class="mb-4">
				<h1 class="h3 fw-bold text-dark mb-2">Sistema de consulta avançada</h1>
				<p class="text-muted">Crie filtros personalizados para obter informações dentre diversas unidades de uma única vez</p>
			</div>
			<div class="mb-4">
				<div class="card rounded-bottom shadow border-0 bg-white bg-opacity-75">
					<div class=" bg-primary text-white rounded-top" style="padding-left: 20px; display: flex; align-items: center; justify-content: space-between; min-height: 70px;">
						<h3 class="h5 mb-0 d-flex align-items-center gap-2">
							<img src="@/assets/images/lupe.png" alt="Search Icon" width="33" height="33" class="me-1" />
							Configuração da consulta
						</h3>
					</div>
					<div class="card-body">
						<div class="mb-4">
							<div class="d-flex align-items-center justify-content-between mb-3">
								<h3 class="h6 fw-semibold text-dark mb-0">Parâmetros de consulta</h3>
								<button @click="addParametroConsulta()" type="button" class="btn btn-outline-secondary d-flex align-items-center gap-2">
									&plus; Adicionar parâmetro
								</button>
							</div>
							<div @click="addParametroConsulta()" v-if="parametrosConsulta.length === 0" class="text-center py-4 text-muted bg-light rounded" style="border: 2px dashed lightgray;">
								<img src="@/assets/images/gray-lupe.png" alt="Search Icon" width="60" height="60" class="me-1 mb-1" />
								<p class="mb-1">Nenhum parâmetro de consulta configurado</p>
								<p class="small">Clique aqui ou em "Adicionar parâmetro" para começar</p>
							</div>
							<div v-else>
								<div v-for="(parametro, index) in parametrosConsulta" :key="index" class="d-flex align-items-center mb-2">
									<div class="d-flex align-items-center py-2 text-muted bg-light rounded border border-dashed flex-grow-1 w-100">
											<div v-if="index > 0" style="margin-left: 10px; width: 90px; display: flex; align-items: center; justify-content: center;">
												<span class="text-white fw-bold" style="background: #33b35a; border-radius: 15%; height: 32px; width: 32px; display: flex; align-items: center; justify-content: center;">E</span>
											</div>
											<input v-if="index == 0" type="text" class="form-control" value="Silos" style="margin-left: 10px; max-width: 90px;" disabled>
											<select v-model="parametro.que_ou_quenao" class="form-control" style="margin-left: 10px; max-width: 85px;">
												<option value="que" selected>que</option>
												<option value="quenao">que não</option>
											</select>
											<select v-model="parametro.tipo" class="form-control" style="margin-left: 10px; max-width: 290px;">
												<option disabled value="">Selecione um parâmetro</option>
												<option value="data==">data e hora</option>
												<option value="nivel_>">nível acima de</option>
												<option value="nivel_<">nível abaixo de</option>
												<option value="produto_==">o produto seja</option>
												<option value="mediaatual_>">média atual acima de</option>
												<option value="mediaatual_<">média atual abaixo de</option>
												<option value="contemaeracaoligada">estejam com a aeração ligada</option>
												<option value="contemcabosoff">contenham sensores off</option>
												<option value="contemsensores_>">contenham temperaturas acima de</option>
												<option value="contemsensores_<">contenham temperaturas abaixo de</option>
											</select>
											<input
												v-if="['contemsensores_>', 'contemsensores_<', 'mediaatual_>', 'mediaatual_<', 'nivel_>', 'nivel_<'].includes(parametro.tipo)"
												v-model.number="parametro.valor"
												type="number"
												class="form-control ms-2"
												style="max-width: 120px;"
												placeholder="Valor"
												min="0"
												required
											>
											<input
												v-if="parametro.tipo === 'data=='"
												v-model="data"
												type="datetime-local"
												class="form-control ms-2"
												style="max-width: 180px;"
												placeholder="Data"
												required
											>
											<select v-if="parametro.tipo === 'produto_=='" v-model="parametro.valor" class="form-control ms-2" style="max-width: 120px;" required>
												<option disabled value="">Selecione o produto</option>
												<option value="Vazio">Vazio</option>
												<option value="Cevada">Cevada</option>
												<option value="Feijão">Feijão</option>
												<option value="Milho">Milho</option>
												<option value="Arroz">Arroz</option>
												<option value="Sorgo">Sorgo</option>
												<option value="Soja">Soja</option>
												<option value="Trigo">Trigo</option>
												<option value="Canola">Canola</option>
												<option value="Azevém">Azevém</option>
												<option value="Linhaça">Linhaça</option>
												<option value="Painço">Painço</option>
												<option value="Alpiste">Alpiste</option>
												<option value="Milheto">Milheto</option>
												<option value="Aveia">Aveia</option>
												<option value="Girassol">Girassol</option>
												<option value="Outro">Outro</option>
											</select>
											<div class="ms-auto d-flex align-items-center" style="height: 100%;">
												<button type="button" class="btn-close parametro-remove-btn" aria-label="Remover" @click="removerParametro(index)" style="font-size: 0.8em; margin-right: 15px;" />
											</div>
										</div>
								</div>
							</div>
						</div>
						<div class="border-top pt-4 mb-4">
							<h3 class="h6 fw-semibold text-dark mb-3">Unidades para consulta</h3>
							<div class="mb-3">
								<div class="d-flex gap-2 align-items-center mb-2">
									<div class="position-relative flex-grow-1">
										<select class="form-control ps-2" v-model="selectedUnidadeId" @change="addSelectedUnidade">
											<option disabled selected value="">Selecione as unidades </option>
											<option v-for="unidade in unidadesDisponiveis" :key="unidade.id" :value="unidade.id">{{ unidade.nome }}</option>
										</select>
									</div>
									<button type="button" class="btn btn-outline-primary" @click="selecionarTodasUnidades">Selecionar todas</button>
									<button type="button" class="btn btn-outline-secondary" @click="limparUnidades">Limpar</button>
								</div>
								<div class="overflow-auto" style="max-height: 240px;">
									<div 
										v-for="unidade in unidadesSelecionadas" 
										:key="unidade.id" 
										class="d-inline-flex align-items-center px-3 py-2 rounded border bg-white mb-2 me-2"
										style="min-width: 0; font-size: 0.95rem;"
									>
										<img src="@/assets/images/sidebar/silos.png" alt="Unidade Icon" width="18" height="18" class="me-1" style="filter: invert(1);" />
										<span class="fw-medium text-dark text-truncate" style=" display: inline-block; overflow: hidden; text-overflow: ellipsis;">{{ unidade.nome }}</span>
										<button type="button" class="btn-close ms-2" aria-label="Remover" @click="removerUnidade(unidade.id)" style="font-size: 0.8em;"	/>
									</div>
									<div v-if="unidadesSelecionadas.length === 0" class="text-muted text-center py-3">
										Nenhuma unidade selecionada
									</div>
								</div>
								<div>
									<h3 class="h6 fw-semibold text-dark mb-3 pt-3 border-top">Colunas a serem exibidas</h3>
									<div>
										<div class="d-flex flex-column flex-wrap gap-2">
											<div class="form-check me-1">
												<input class="form-check-input" type="checkbox" id="col-nome" checked disabled>
												<label class="form-check-label user-select-none" for="col-nome">Silo</label>
											</div>
											<div class="form-check me-1">
												<input class="form-check-input" type="checkbox" id="col-nivel" v-model="colunasTable.nivel">
												<label class="form-check-label user-select-none" for="col-nivel">Nível</label>
											</div>
											<div class="form-check me-1">
												<input class="form-check-input" type="checkbox" id="col-produto" v-model="colunasTable.produto">
												<label class="form-check-label user-select-none" for="col-produto">Produto</label>
											</div>
											<div class="form-check me-1">
												<input class="form-check-input" type="checkbox" id="col-data-ultimo-registro" v-model="colunasTable.data_ultimo_registro">
												<label class="form-check-label user-select-none" for="col-data-ultimo-registro">Data do registro</label>
											</div>
											<div class="form-check me-1">
												<input class="form-check-input" type="checkbox" id="col-media-atual" v-model="colunasTable.media_atual">
												<label class="form-check-label user-select-none" for="col-media-atual">Média do grão</label>
											</div>
											<div class="form-check me-1">
												<input class="form-check-input" type="checkbox" id="col-status-motores" v-model="colunasTable.status_motores">
												<label class="form-check-label user-select-none" for="col-status-motores">Status aeração</label>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div class="d-flex gap-2 pt-4 border-top">
							<button type="button" class="btn btn-primary d-flex align-items-center gap-2" @click="executarConsulta()">
								<img src="@/assets/images/lupe.png" alt="Search Icon" width="22" height="22" class="me-1" />
								Executar Consulta
							</button>
						</div>
					</div>
				</div>
			</div>
			<div v-if="consultaFeita" class="card rounded-bottom shadow border-0 bg-white bg-opacity-75 mb-8">
				<div class="bg-success text-white rounded-top"  style=" padding-inline: 20px; display: flex; align-items: center; justify-content: space-between; min-height: 70px;">
					<div class="d-flex align-items-center justify-content-between w-100">
						<h3 class="h5 mb-0 d-flex align-items-center gap-2">
							<img src="@/assets/images/database.png" alt="Data Icon" width="22" height="22" class="me-1" style="filter: invert(1);" />
							Resultado da Consulta
						</h3>
						<span class="badge bg-light text-success rounded">{{totalSilos}} resultado(s)</span>
					</div>
				</div>
				<div v-if="resultUnidadesWithSilos < 1" class="card-body">
					<div class="text-center py-5 text-muted">
						<img src="@/assets/images/database.png" alt="Data Icon" width="50" height="50" class="me-1 mb-3" style="opacity: 70%;" />
						<h3 class="h6 fw-medium mb-2">Nenhum resultado encontrado</h3>
						<p class="text-secondary">Revise os parâmetros de consulta e execute a busca novamente</p>
					</div>
				</div>
				<div v-else class="card-body">
					<div 
						v-for="unidade in resultUnidadesWithSilos" 
						:key="unidade.id" 
						class="mb-4 p-0 rounded shadow-sm border bg-white"
						style="overflow: hidden;"
					>
						<div class="bg-light px-4 py-3 d-flex align-items-center gap-2 border-bottom">
							<img src="@/assets/images/sidebar/silos.png" alt="Unidade Icon" width="18" height="18" class="me-1" style="filter: invert(1);" />
							<h4 class="h6 fw-bold mb-0 text-dark flex-grow-1 text-start">{{ unidade.nome }}</h4>
						</div>
						<div class="p-3">
							<table class="table table-striped table-bordered">
								<thead class="thead-dark">
									<tr>
										<th scope="col" class="text-center" style="vertical-align: middle;"><h6>Local</h6></th>
										<th v-if="colunasTable.produto" scope="col" class="text-center" style="vertical-align: middle;"><h6 >Produto (Atual)</h6></th>
										<th v-if="colunasTable.data_ultimo_registro" scope="col" class="text-center" style="vertical-align: middle;"><h6 >Data do Registro</h6></th>
										<th v-if="colunasTable.nivel" scope="col" class="text-center" style="vertical-align: middle;"><h6 >Nível</h6></th>
										<th v-if="colunasTable.media_atual" scope="col" class="text-center" style="vertical-align: middle;"><h6 >Média (Atual)</h6></th>
										<th v-if="colunasTable.status_motores" scope="col" class="text-center" style="vertical-align: middle;"><h6 >Motores</h6></th>
										<th 
											v-if="parametrosConsulta.some(p => p.tipo === 'contemcabosoff')" 
											scope="col" 
											class="text-center" 
											style="vertical-align: middle;"
										>
											<h6>Sensores OFF</h6>
										</th>
										<th 
											v-if="parametrosConsulta.some(p => (p.tipo === 'contemsensores_<' || p.tipo === 'contemsensores_>'))" 
											scope="col" 
											class="text-center" 
											style="vertical-align: middle;"
										>
											<h6>Sensores encontrados</h6>
										</th>
										<th scope="col" class="text-center" style="vertical-align: middle;"><h6>Ações</h6></th>
									</tr>
								</thead>
								<tbody>
									<tr v-for="silo in unidade.silos" :key="silo.index">
										<td class="text-center" style="padding: none; vertical-align: middle;">{{ silo.nome }}</td>
										<td v-if="colunasTable.produto" class="text-center" style="vertical-align: middle;">{{ silo.ultima_leitura.produto}}</td>
										<td v-if="colunasTable.data_ultimo_registro" class="text-center" style="vertical-align: middle;">{{ silo.ultima_leitura.data }}</td>
										<td v-if="colunasTable.nivel" class="text-center" style="vertical-align: middle;">
											<div class="progress position-relative" style="height: 28px; background-color: #b8b4b4;">
												<div class="progress-bar green" :style="'width: ' + (silo.nivel) + '%; color: black; overflow: visible; height: 100%;'">
												</div>
												<span class="position-absolute top-50 start-50 translate-middle">
													{{ (silo.nivel).toFixed(2) }} %
												</span>
											</div>
											<span style="color: #918888; font-size: 11px; padding: 0;">
												{{parseInt((silo.nivel / 100) * parseInt(silo.capacidade))}} / {{parseInt(silo.capacidade)}}
											</span>
										</td>
										<td v-if="colunasTable.media_atual" class="text-center" style="font-weight: bold; vertical-align: middle;" :style="{ color: getCorPorTemperatura(silo.media_atual) }">{{ silo.media_atual}} ºC</td>
										<td v-if="colunasTable.status_motores" class="text-center" style="vertical-align: middle;">
											<ul v-if="(silo.aeracao == null)" class="list-unstyled d-grid justify-content-center" style="margin: 0; padding: 0;">
												<h6 class="align-items-center d-flex">Silo sem aeração</h6>
											</ul>
											<ul v-else class="list-unstyled d-grid justify-content-center" style="margin: 0; padding: 0;">
												<div v-for="motor in silo.aeracao.motores" :key="motor.id" 
													:class="[
														motor.status == 1 ? 'bg-success text-success' : 'bg-danger text-danger border-danger',
														'align-items-center',
														'px-2',
														'py-1',
														'mb-1',
														'rounded',
														'bg-opacity-10'
													]" 
													style="font-size: 0.85em; display: inline-flex; max-width: 220px; margin-right: 6px; white-space: nowrap;"
												>
													<span class="fw-medium text-truncate" style="max-width: 90px; overflow: hidden;">{{motor.descricao}}</span>
													<span :class="[motor.status == 1 ? 'bg-success' : 'bg-danger', 'badge', 'ms-2', 'rounded']">{{motor.status == 1 ? 'Ligado' : 'Desligado'}}</span>
												</div>
											</ul>
										</td>
										<td v-if="parametrosConsulta.some(p => p.tipo === 'contemcabosoff')" class="text-center" style="vertical-align: middle;">
											<ul class="list-unstyled d-grid justify-content-center" style="margin: 0; padding: 0;">
												<div v-if="silo.sensores_off && Object.keys(silo.sensores_off).length > 0">
													<b 
														class="text-danger px-2 py-1"
														style="border: 1px solid red; border-radius: 8px; background-color: rgb(255, 0, 0, 0.1);"
														:tabindex="0"
														@mouseover="showOffPopoverIndex = silo.id"
														@mouseleave="showOffPopoverIndex = null"
													>
													{{ Object.values(silo.sensores_off).reduce((acc, sensores) => acc + sensores.length, 0) }} problema(s)
												</b>
													<div
														v-if="showOffPopoverIndex === silo.id"
														class="popover-custom"
														style="position: absolute; z-index: 999; background: #fff; border: 1px solid #ccc; border-radius: 8px; padding: 8px; min-width: 180px;"
													>
													<ul class="mb-0 ps-3 " style="list-style-type: none; margin: 0; padding: 0;">
															<li style="text-align: start;" v-for="(sensores, cabo) in silo.sensores_off" :key="cabo">
																Cabo {{ cabo }}: 
																<span v-for="(sensor, idx) in sensores" :key="sensor">
																	{{ sensor }}<span v-if="idx < sensores.length - 1">, </span>
																</span>
															</li>
														</ul>
													</div>
												</div>
											</ul>
										</td>
										<td v-if="parametrosConsulta.some(p => (p.tipo === 'contemsensores_>' || p.tipo === 'contemsensores_<'))" class="text-center" style="vertical-align: middle;">
											<ul class="list-unstyled d-grid justify-content-center" style="margin: 0; padding: 0;">
												<div v-if="silo.sensores_match && Object.keys(silo.sensores_match).length > 0">
													<b 
														class="px-2 py-1"
														style="font-weight: bold; border-radius: 8px; background-color: rgb(237 178 0 / 67%);"
														:tabindex="0"
														@mouseover="showMatchPopoverIndex = silo.id"
														@mouseleave="showMatchPopoverIndex = null"
													>
														{{ Object.values(silo.sensores_match).reduce((acc, sensores) => acc + sensores.length, 0) }} sensor(es)
													</b>
													<div
														v-if="showMatchPopoverIndex === silo.id"
														class="popover-custom"
														style="position: absolute; z-index: 999; background: #fff; border: 1px solid #ccc; border-radius: 8px; padding: 8px; min-width: 280px;"
													>
													<ul class="m-0" style="list-style-type: none; margin: 0; padding: 0;">
															<li style="text-align: start;" v-for="(sensores, cabo) in silo.sensores_match" :key="cabo">
																Cabo {{ cabo }}: 
																<span v-for="(sensor) in sensores" :key="sensor" class="badge rounded-pill text-dark" :style="{ backgroundColor: getCorPorTemperatura(sensor.temperatura) }" style="margin-left: 2px; font-size: 0.85em; padding: 0.2em 0.5em;">
																	{{ sensor.sensor }}|{{ sensor.temperatura }}
																</span>
															</li>
														</ul>
													</div>
												</div>
											</ul>
										</td>
										<td class="text-center" style="padding: none; vertical-align: middle;">
											<a @click="openInNewTab(unidade.id, silo.id)" class="text-primary text-decoration-underline" style="cursor: pointer;">
												Acessar silo
											</a>
										</td>
									</tr>
								</tbody>
							</table>
						</div>
					</div>
				</div>
			</div>
		</div>
	</UnidadeLayout>
</template>
<script>
import temperaturaCores from "@/assets/colors.json";
import UnidadeLayout from "@/components/layouts/UnidadeLayout.vue";
import LoaderPage from "@/components/ui/LoaderPage.vue";
import ConsultaSwitch from "@/components/ui/App/ConsultaSwitch.vue";
import { ref, onMounted, computed } from "vue";
import { useStore } from "vuex";
import { useToast } from 'vue-toastification';

export default {
	name: "ConsultaAvancadaPage",
	components: {
		UnidadeLayout,
		LoaderPage,
		ConsultaSwitch,
	},
	methods: {
		openInNewTab(unidadeId, siloId) {
			const route = this.$router.resolve(`/v1/unidades/${unidadeId}/silos/${siloId}`);
			window.open(route.href, '_blank');
		}
	},
	data() {
		return {
			showOffPopoverIndex: null,
			showMatchPopoverIndex: null,
		};
	},
	setup() {
		const store = useStore();
		const toast = useToast();
		const vue_app_name = process.env.VUE_APP_NAME;

		const unidades = ref([]);
		const unidadesSelecionadas = ref([]);
		const selectedUnidadeId = ref("");
		const parametrosConsulta = ref([]);
		const loadingPage = ref(false);
		const resultUnidadesWithSilos = ref([]);
		const colunasTable = ref({});
		const consultaFeita = ref(false);

		const now = new Date();
		now.setHours(now.getHours() - 3);
		const dataInicial = ref(now.toISOString().slice(0, 16));
		const data = ref(dataInicial.value);

		const getCorPorTemperatura = (temp) => {
			temp = Number(temp);

            const faixas = Object.keys(temperaturaCores)
                .map(Number)
                .sort((a, b) => a - b);            

            for (let i = 0; i <= faixas.length - 1; i++) {
                if (temp <= faixas[i]) {
                    return temperaturaCores[faixas[i]];
                }
            }

            return "#c31313";
		};

		const addParametroConsulta = () => {
			consultaFeita.value = false;
			parametrosConsulta.value.push({
				que_ou_quenao: "que",
				tipo: "",
				valor: null
			});
		};

		const removerParametro = (index) => {
			const param = parametrosConsulta.value[index];
			parametrosConsulta.value.splice(index, 1);
			if (param && param.tipo === "data==") {
				data.value = dataInicial.value;
			}
		};

		const addSelectedUnidade = () => {
			const unidade = unidadesDisponiveis.value.find(u => u.id === selectedUnidadeId.value);
			if (unidade && !unidadesSelecionadas.value.some(u => u.id === unidade.id)) {
				unidadesSelecionadas.value.push(unidade);
			}
			selectedUnidadeId.value = "";
		};

		const removerUnidade = (id) => {
			unidadesSelecionadas.value = unidadesSelecionadas.value.filter(u => u.id !== id);
		};

		const selecionarTodasUnidades = () => {
			unidadesSelecionadas.value = [];
			unidadesSelecionadas.value = [...unidadesDisponiveis.value];
		};

		const limparUnidades = () => {
			unidadesSelecionadas.value = [];
		};

		const totalSilos = computed(() => {
			return resultUnidadesWithSilos.value.reduce((total, unidade) => total + (unidade.silos ? unidade.silos.length : 0), 0);
		});

		const unidadesDisponiveis = computed(() => {
			return unidades.value.filter(
				u => !unidadesSelecionadas.value.some(sel => sel.id === u.id)
			);
		});

		const executarConsulta = async () => {
			consultaFeita.value = false;
			loadingPage.value = true;
			if (unidadesSelecionadas.value.length === 0) {
				toast.error("Selecione pelo menos uma unidade.");
				loadingPage.value = false;
				return;
			}
			const ids = unidadesSelecionadas.value.map(u => u.id);
			const regras = parametrosConsulta.value
				.filter(param => param.tipo !== "data==")
				.map(param => {
				let str = param.que_ou_quenao;
				str += "_" + param.tipo + "_";
				str+= param.valor !== null ? param.valor : "0";
				return str;
			});
			let resultUnidades = await store.dispatch("unidades/fetchUnidadesConsultaAvancada", {ids, regras, data: data.value});
			resultUnidadesWithSilos.value = resultUnidades.filter(unidade => unidade.silos && unidade.silos.length > 0);
			loadingPage.value = false;
			consultaFeita.value = true;
			toast.success("Consulta executada com sucesso!");
		};

		onMounted(async () => {
			try {
				unidades.value = store.state.unidades.unidades.filter(u => u.status === 'ativo');
				if (unidades.value.length === 0) {
					await store.dispatch("unidades/fetchUnidades");
					unidades.value = store.state.unidades.unidades.filter(u => u.status === 'ativo');
				}
			} catch (error) {
				console.error("Erro ao buscar unidades:", error);
				toast.error("Erro ao buscar unidades");
			}
		});

		return {
			unidades,
			unidadesSelecionadas,
			selectedUnidadeId,
			unidadesDisponiveis,
			vue_app_name,
			parametrosConsulta,
			executarConsulta,
			loadingPage,
			resultUnidadesWithSilos,
			totalSilos,
			colunasTable,
			addParametroConsulta,
			removerParametro,
			addSelectedUnidade,
			removerUnidade,
			selecionarTodasUnidades,
			limparUnidades,
			consultaFeita,
			getCorPorTemperatura,
			data
		};
	},
};
</script>

<style scoped>
.nav-bar-unidade {
    box-shadow: -3px 2px 20px 0px #999191;
    background-color: #f7f7f7 !important;
}
h6 {
	margin: 0;
}
</style>